import React, { Component } from 'react';
import './LoginForm.css';
import {Redirect} from 'react-router-dom'
import {auth} from '../../../../Config/Firebase'

import './LoginForm.css'
import HavenLogo from '../../../Images/MyHavenLogo.png'
import {Link} from 'react-router-dom'
import Loader from 'react-loader-spinner'
import Referrals from '../../../Images/Referrals.png'
//redux 
import { connect } from 'react-redux'
import { hideLoading } from '../../../../Actions/loadingAction'
import PasswordResetEmailForm from './PasswordResetEmailForm';


class ReferralsLogin extends Component {
    constructor(props){
        super(props);
        this.state = {
            email: '',
            password: '',
           showPasswordResetForm: false
           
        };
    }
    
    componentWillMount () {
        setTimeout(() => {
            this.props.hideLoading();
        }, 1000);
    }
   
//login  to firebase
login = (event) => {
    event.preventDefault()

    auth.signInWithEmailAndPassword(this.state.email, this.state.password).catch((error) =>{            
        console.log(error.code);

        if(error.code === "auth/wrong-password") {
            document.getElementById('email-label').style.color = "#acacac";
            document.getElementById('email-label').innerText = "Email";
            document.getElementById('pass-label').style.color = "red";
            document.getElementById('pass-label').innerText = "Incorrect Password";
        } else if (error.code === "auth/user-not-found"){
            document.getElementById('email-label').style.color = "red";
            document.getElementById('email-label').innerText = "Email Not Found";
            document.getElementById('pass-label').style.color = "#acacac";
            document.getElementById('pass-label').innerText = "Password";
        
        } else if (error.code === "auth/invalid-email"){
            document.getElementById('email-label').style.color = "red";
            document.getElementById('email-label').innerText = "Email is Invalid";
            document.getElementById('pass-label').style.color = "#acacac";
            document.getElementById('pass-label').innerText = "Password";
        }
       
    })
}

//show login form
showLogin = () => {
    this.setState({
        showPasswordResetForm: false
    })
}

//send password reset email
sendPasswordReset = () => {
    this.setState({
        showPasswordResetForm: true
    })
}

render() { 

    const { from } = this.props.location.state || { from: { pathname: "/dashboard" } };
    if (this.props.is_authenticated_prop !== null) {
        return <Redirect to={from} />;
      }
       
      if(this.props.loading === true) {
        return (
         <div style={{ textAlign: "center", position: "absolute", top: "50%", left: "50%", marginTop: "-50px", marginLeft: "-50px", width: "100px", height: "100px" }}>

               <Loader 
                type="TailSpin"
                color="#001e61"
                height="100"	
                width="100"
                /> 
            </div>
        )
    }
     
       return ( 

            <div className="loginPageDiv">
                {this.state.showPasswordResetForm ? 

                <PasswordResetEmailForm showLogin = {this.showLogin}/> 
                
                : 
            
                <div className="page">
           
                        <div className="container-fluid login-form-div">
                        <div className="row">
                            <div className="col-xl-6 leftSideLogin">
                                <form className="login-form"onSubmit={(event) => { this.login(event) }}>
                                    <li>
                                    <h3 id="formTitle">Westhaven Referrals</h3>
                                       <br/>
                                        <hr/>
                                    </li>
                                    <li>
                                        <label  id="email-label">EMAIL</label>
                                       
                                    </li>
                                    <li>
                                        <input type="email" id="emailInput" placeholder="Email" onChange={(event) => this.setState({ email: event.target.value})}/>
                                    </li>
                                    <li>
                                        <label id="pass-label" >PASSWORD</label>
                                       
                                    </li>
                                    <li>
                                        <input type="password" id="passwordInput" placeholder="Password" onChange={(event) => this.setState({ password: event.target.value})}/>
                                        <hr/>
                                    </li>
                                    <li>
                                        <button type="submit"className="btn btn-primary large">Login</button>
                                    </li>
                                    <li id="bottom-nav"><a onClick={this.sendPasswordReset}>Forgot Password</a><span> | </span><Link to="/register">Register for Referrals</Link></li>
                                </form>
                        
                            </div>
                            <div className="d-none d-lg-block col-xl-6 rightSideLogin">
                            <div className="rightPanelDiv">
                                    <img src={Referrals} alt="Image of MyHaven" width="400px"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>}
            </div>
 
            
         )
    }
}
 

const mapStateToProps = state => ({
    is_authenticated_prop: state.is_authenticated.is_authenticated,
    email: state.firebase.email,
    loading: state.loading.loading
    
  })

  const mapDispatchToProps = (dispatch) => {
    return {
      
        hideLoading: () => dispatch(hideLoading("SHOW_LOADING"))
    }
  }

  export default connect(mapStateToProps, mapDispatchToProps) (ReferralsLogin);
  
  




// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/LoginPage/ReferralsLogin.jsx